/*
Dilip 02/02/2023 3031450488 addded download functionality for data manager Execution History
Dilip 02/03/2023 3075154998  form label changes
suresh peddavoora 02/22/2023 3075154998 New UI changes implemented
Prakash 03/17/2023 2701335619 fixed alignments in responsive.
Prakash 03/20/2023 3075154998 fixed alignments issues.
Ravi 06/12/2023 3075154998 Added Failed in status Dropdown.
Sohel 12/12/2023 3075154998 removed upperCase from code field
Sohel 12/12/2023 3075154998 label name code change to import/export name
*/
import {Button, FormHelperText, TextField} from '@material-ui/core';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {Form, Formik} from 'formik';
import React, {useEffect, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import DmExecutionSearchTable from './DmExecutionSearchTable';
import {getAllReportCreatedForData} from '../../../../../redux/reducers/ReportMaster';
import DateFnsUtils from '@date-io/date-fns';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import * as Yup from 'yup';
import {createForOptions} from '../../../../../util/CreatedByForOptions';
const DmExecutionSearch = ({type}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [submit, setSubmit] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);
  const [searchData, setSearchData] = useState({});
  const {reportCreatedForData} = useSelector(({reportMaster}) => reportMaster);
  const dispatch = useDispatch();
  //   const StatusOptions = [
  //     { key: "Y", value: "Draft" },
  //     { key: "N", value: "Completed" },
  //   ];
  const importManagerType = [{value: 'New Account Import'}, {value: 'Data Update'}];
  const exportManagerType = [{value: 'Data Export'}];
  const executionModuleName = type === 'Export' ? "Export Name" : "Import Name"
  const StatusOptions = ['COMPLETED', 'FAILED', 'IN_PROGRESS'];

  const handleSubmit = (data) => {
    setSubmit(true);
    setSearchFlag(true);
    setSearchData(data);
  };
  const validationSchema = Yup.object().shape({
    executedFrom: Yup.date().typeError('Invalid date format').nullable(),
    executedTo: Yup.date().typeError('Invalid date format').nullable(),
  });
  const initialValues = {
    dataManagerCode: '',
    dataManagerType: '',
    status: '',
    executedBy: '',
    executedTo: null,
    executedFrom: null,
  };

  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);

  return (
    <div>
      <h2 className="search-title">Execution Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {(props) => {
          const { values, handleChange, handleReset, setFieldValue, handleBlur, errors, touched } =
            props;
          return (
            <div>
              <Form autoComplete="off" noValidate>
                <div>
                  <ErrorBoundaryForComponents>
                    <div className="form-row standard-field-textfields new-standard-textfields">
                      <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-2 form-group`}>
                        <TextField
                          margin="dense"
                          className={`${classes.labelName}`}
                          variant="outlined"
                          placeholder={`Enter ${executionModuleName}`}
                          label={`${executionModuleName}`}
                          name="dataManagerCode"
                          value={values?.dataManagerCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.dataManagerCode}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="dataManagerType"
                          id="dataManagerType"
                          size="small"
                          value={values.dataManagerType}
                          options={type === 'Export' ? exportManagerType : importManagerType}
                          getOptionLabel={(option) => {
                            return option && option.value;
                          }}
                          onChange={(e, value) => {
                            setFieldValue('dataManagerType', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Type"
                                placeholder="Select Type"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className=" col-md-4 col-lg-3  col-xl-2 form-group">
                        <GuiAutoComplete
                          {...props}
                          classes={{
                            option: classes.option,
                            popper: classes.popper,
                          }}
                          name="status"
                          id="status"
                          size="small"
                          value={values.status}
                          options={StatusOptions}
                          required
                          onChange={(e, value) => {
                            setFieldValue('status', value);
                          }}
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={`${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                label="Status"
                                placeholder="Select Status"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="executedBy"
                          id="executedBy"
                          size="small"
                          value={values.executedBy}
                          options={reportCreatedForData}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createForOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('executedBy', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Executed By"
                                placeholder="Select Executed By"
                              />
                              <FormHelperText variant="outlined">
                                {touched.createdFor && errors.createdFor}
                              </FormHelperText>
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={`${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.executedFrom}
                            name="executedFrom"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Start Date"
                            onChange={(val) => {
                              setFieldValue('executedFrom', val);
                            }}
                            autoOk
                            margin="dense"
                            error={Boolean(touched?.executedFrom && errors?.executedFrom)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.executedFrom && errors.executedFrom ? errors.executedFrom : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={`${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.executedTo}
                            name="executedTo"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="End Date"
                            onChange={(val) => {
                              setFieldValue('executedTo', val);
                            }}
                            autoOk
                            margin="dense"
                            error={Boolean(touched?.executedTo && errors?.executedTo)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.executedTo && errors.executedTo ? errors.executedTo : ''}
                        </FormHelperText>
                      </div>

                      <div className="col-md-12 col-lg-4 col-xl-12 form-group new-standard-textfields">
                        <div className="d-flex justify-content-center justify-content-lg-start justify-content-xl-center">
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn ${classes.buttonRoot}`}
                            onClick={() => {
                              handleReset();
                              setSearchData({});
                              setSubmit(true);
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="outlined"
                            type="submit"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ErrorBoundaryForComponents>
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
      <DmExecutionSearchTable
        searchData={searchData}
        setSubmit={setSubmit}
        setSearchFlag={setSearchFlag}
        setSearchData={setSearchData}
        submit={submit}
        searchFlag={searchFlag}
        type={type}
      />
    </div>
  );
};

export default DmExecutionSearch;
